/** Hero background for account-area pages (profile, clients, bookings, commissions, bank, contact). */
export const ACCOUNT_PAGES_HERO_IMAGE_URL =
  'https://s3.eu-north-1.amazonaws.com/spaceaxonall.com/origin+mvp+assets/Email_Templates/Email+Tempt+v3/image_gp7.jpeg'
